import { get, put, post, getToken } from 'api/axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL;

const getPaymentPlan = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/paymentPlan`);
};

const getPaymentPlanSummary = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/paymentPlanSummary`);
};

const getDocumentScheduleCellParams = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/documentScheduleCellParams`);
};

const getScheduleTypeCellParamTemplates = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/schedule-type-cell-param-templates`);
};

const getScheduleTypeParams = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/schedule-type-params`);
};

const getDocumentScheduleParams = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/document-schedule-params`);
};

const updateDocumentScheduleParams = data => {
  const { documentId, siteId, documentScheduleParams } = data;
  return put(`${url}/leasingoffers/${documentId}/${siteId}/document-schedule-params`, {
    documentId,
    siteId,
    documentScheduleParams
  });
};

const updateDocumentScheduleCellParams = (documentId, siteId, scheduleCellParams, scheduleTypeCellParamTemplateId) => {
  return put(`${url}/leasingoffers/${documentId}/${siteId}/documentScheduleCellParams`, {
    documentId,
    siteId,
    scheduleCellParams,
    scheduleTypeCellParamTemplateId
  });
};

const getAdvanceSplit = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/getAdvanceSplit`);
};

const saveAdvanceSplit = advanceSplit => {
  return post(`${url}/leasingoffers/${advanceSplit.documentId}/${advanceSplit.siteId}/savesplitadvance`, advanceSplit);
};

const importPaymentPlan = (documentId, siteId, file) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/importPaymentPlan`, { documentId, siteId, file });
};

const exportPaymentPlan = (documentId, siteId, fileName, isVatFinancingSimulation) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/${fileName}/${isVatFinancingSimulation}/exportPaymentPlan`);
};

const exportPaymentPlanExcel = (documentId, siteId, fileName, isVatFinancingSimulation) => {
  return `${url}/leasingoffers/${documentId}/${siteId}/${fileName}/${isVatFinancingSimulation}/exportPaymentPlanExcel?access_token=${getToken()}`;
};

const generateInvoice = (documentId, siteId) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/generate-invoice`);
};

const cancelInvoice = (documentId, siteId) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/cancel-invoice`);
};

const downloadInvoice = (documentId, siteId) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/download-invoice`);
};

const exp = {
  getPaymentPlan,
  getPaymentPlanSummary,
  getDocumentScheduleCellParams,
  updateDocumentScheduleCellParams,
  getScheduleTypeParams,
  getDocumentScheduleParams,
  updateDocumentScheduleParams,
  getAdvanceSplit,
  saveAdvanceSplit,
  importPaymentPlan,
  getScheduleTypeCellParamTemplates,
  exportPaymentPlan,
  exportPaymentPlanExcel,
  generateInvoice,
  cancelInvoice,
  downloadInvoice
};
export default exp;
